export default {
  listaPagamentoRecebimentos: [],
  pagamentoRecebimento: {
    id: '',
    registro: '',
    descricao: '',
    observacao: '',
    dataLancamento: null,
    dataVencimento: null,
    dataQuitacao: null,
    valor: 0.0,
    desconto: 0.0,
    juro: 0.0,
    multa: 0.0,
    valorTotal: 0.0,
    valorQuitado: 0.0,
    obs: null,
    tipo: null,
    formaPagamento: null,
    situacao: null,
    ativo: true,
  },
  comboSituacao: [
    { id: 'ABERTO', nome: 'Aberto' },
    { id: 'VENCIDO', nome: 'Vencido' },
    { id: 'QUITADO', nome: 'Quitado' },
    { id: 'CANCELADO', nome: 'Cancelado' },
    { id: 'PAGO_A_MENOR', nome: 'Pago a menor' },
  ],
  TIPO_PAGAMENTO: 0,
  TIPO_RECEBIMENTO: 1,
  totalizacao: {
    totalReceita: 0,
    totalDespesa: 0,
    balancoMensal: 0,
    saldoAtual: 0,
  },
}
